import {Component, Input} from '@angular/core';
import * as moment from 'moment';
import * as Validations from '../../../../shared/constants/validation.constants';
import {MetricOptionModel} from '../../../../../models/metric-option.model';
import {MetricValueItem} from '../../models/fetch-metric-values.model';
import {AbstractControl, FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {measurements} from '../../../../shared/constants/common.constants';
import {CommonService} from '../../../../shared/services/common.service';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../../../state/app.state';
import {EditMetricValueListRequest, EditMetricValueRequest} from '../../core/metrics.actions';

@Component({
  selector: 'app-edit-data-combined',
  templateUrl: './edit-data-combined.component.html',
  styleUrls: ['./edit-data-combined.component.css']
})
export class EditDataCombinedComponent {
  @Input() data: any;
  maxDate = moment();

  validations = Validations;
  metricOption: MetricOptionModel;
  metricValue: MetricValueItem;
  errorMessages: any = {};
  errorMessageMap = {
    recordedOn: {
      required: 'This field is required.',
      matDatepickerMax: 'Future date is not allowed.'
    },
    height: {
      required: 'This field is required.',
      pattern: 'Invalid value.', // This is for bp metric option
      invalid: 'Systolic or diastolic value must not be zero.', // This is
      // for bp metric option
      min: '', // This is empty as of now, it's required and filled only for
      // metric option height and weight
    },
    weight: {
      required: 'This field is required.',
      pattern: 'Invalid value.', // This is for bp metric option
      invalid: 'Systolic or diastolic value must not be zero.', // This is
      // for bp metric option
      min: '', // This is empty as of now, it's required and filled only for
      // metric option height and weight
    },
  }
  form = new FormGroup<any>({
    recordedOn: new FormControl('', [Validators.required]),
    // value: new FormControl('', [Validators.required]),
  })

  constants = measurements;

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
  ) {
  }

  ngOnInit() {
    this.metricOption = this.data['metricOption'];
    this.metricValue = this.data['metricValue'];

    // if option is height then add min height validator
    if (this.metricValue['height']) {
      this.errorMessageMap.height.min = 'Height must be minimum half feet.';
      this.form.addControl('height', new FormControl(this.metricValue['height'].value, [
        Validators.required,
        Validators.min(this.validations.measurements.height.min),
      ]))
    }

    // if option is weight then add min weight validator
    if (this.metricValue['weight']) {
      this.errorMessageMap.weight.min = 'Weight must be minimum 1 pound.';
      this.form.addControl('weight', new FormControl(this.metricValue['weight'].value, [
        Validators.required,
        Validators.min(this.validations.measurements.weight.min),
      ]))
    }

    this.form.patchValue({
      recordedOn: this.metricValue.recordedOn,
    })
  }

  handleSubmit() {
    if (this.form.invalid) {
      this.errorMessages = this.commonService.checkFormValidation(this.form, this.errorMessageMap);
      return;
    }

    if (!this.form.dirty) {
      this.commonService.closeDialog();
      return;
    }

    const rawValue = this.form.getRawValue();

    const payload = {
      values: [],
    };

    if (rawValue.height) {
      payload.values.push({
        valueId: this.metricValue['height'].id,
        recordedOn: rawValue.recordedOn,
        value: rawValue.height.toString(),
      })
    }

    if (rawValue.weight) {
      payload.values.push({
        valueId: this.metricValue['weight'].id,
        recordedOn: moment(rawValue.recordedOn).format('YYYY-MM-DD'),
        value: rawValue.weight.toString(),
      })
    }

    // call edit multiple api
    this.store.dispatch(EditMetricValueListRequest({
      payload: {
        ...payload,
        extras: this.data['extras'],
      }
    }))
  }

  handleCancel() {
    this.commonService.closeDialog();
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }
}
